import FeatureGates from '@atlaskit/feature-gate-js-client';

import { GateNames } from './gate-keys';

/**
 * @deprecated Please use fg instead.
 * For context see https://hello.atlassian.net/wiki/spaces/STATUS/pages/5931337789/RFC+We+should+align+on+standard+feature+gating+and+experiment+patterns+in+Townsquare
 */
export const useFeatureGate = (gateName: GateNames): boolean => {
	// Need to update a bunch of tests first - https://product-fabric.atlassian.net/browse/TC-8019
	// if (!FeatureGates.initializeCompleted()) {
	//   throw new Error(
	//     'useFeatureGate was called with Feature gates not initialized! Your component is probably rendered outside of <FeatureGatesInitialization>',
	//   );
	// }
	return FeatureGates.checkGate(gateName);
};

/**
 * @deprecated Please use fg instead.
 * For context see https://hello.atlassian.net/wiki/spaces/STATUS/pages/5931337789/RFC+We+should+align+on+standard+feature+gating+and+experiment+patterns+in+Townsquare
 */
export function isGateEnabled(gateName: GateNames): boolean {
	// Need to update a bunch of tests first - https://product-fabric.atlassian.net/browse/TC-8019
	// if (!FeatureGates.initializeCompleted()) {
	//   throw new Error(
	//     'isGateEnabled was called with Feature gates not initialized! Your component is probably rendered outside of <FeatureGatesInitialization>',
	//   );
	// }

	return FeatureGates.checkGate(gateName);
}

export function fg(gateName: GateNames): boolean {
	return FeatureGates.checkGate(gateName);
}
